import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VRow,
    [
      _vm.mode !== "hidden"
        ? _c(
            VCol,
            { staticClass: "pb-0", attrs: { cols: "12" } },
            [
              _vm.mode === "notification"
                ? _c("ReviewNotification", { attrs: { value: _vm.value } })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(VCol, { attrs: { cols: "12" } }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm.mode !== "hidden"
        ? _c(
            VCol,
            { staticClass: "footer", attrs: { cols: "12" } },
            [
              _vm.mode === "review"
                ? _c(
                    "AdminReview",
                    _vm._g({ attrs: { value: _vm.value } }, _vm.$listeners)
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }